(function ($, undefined) {
    $.fn.hasHandler = function (eventName) {
        var countFound = 0;
        var eventData = $(this).data('events');

        for (e in eventData) {
            if (eventData.hasOwnProperty(e)) {
                countFound++;
            }
        }

        return countFound > 0;
    }

        /**
        * @attribute destroyed
        * @parent specialevents
        * @download  http://jmvcsite.heroku.com/pluginify?plugins[]=jquery/dom/destroyed/destroyed.js
        * @test jquery/event/destroyed/qunit.html
        * Provides a destroyed event on an element.
        * <p>
        * The destroyed event is called when the element
        * is removed as a result of jQuery DOM manipulators like remove, html,
        * replaceWith, etc. Destroyed events do not bubble, so make sure you don't use live or delegate with destroyed
        * events.
        * </p>
        * <h2>Quick Example</h2>
        * @codestart
        * $(".foo").bind("destroyed", function(){
        *    //clean up code
        * })
        * @codeend
        * <h2>Quick Demo</h2>
        * @demo jquery/event/destroyed/destroyed.html 
        * <h2>More Involved Demo</h2>
        * @demo jquery/event/destroyed/destroyed_menu.html 
        */

        var oldClean = jQuery.cleanData;

        $.cleanData = function (elems) {
            try {
                for (var i = 0, elem;
		    (elem = elems[i]) !== undefined; i++) {
                    $(elem).triggerHandler("destroyed");
                    //$.event.remove( elem, 'destroyed' );
                }
            }
            catch (ex) {

            }
            oldClean(elems);
        };

    $.extend($, { 'hasHandler': $.fn.hasHandler });

    (function ($) {
        $.fn.outerHTML = function () {
            return $(this).clone().wrap('<div></div>').parent().html();
        }
    })(jQuery);


    var types = ['DOMMouseScroll', 'mousewheel'];

    if ($.event.fixHooks) {
        for (var i = types.length; i; ) {
            $.event.fixHooks[types[--i]] = $.event.mouseHooks;
        }
    }

    $.event.special.mousewheel = {
        setup: function () {
            if (this.addEventListener) {
                for (var i = types.length; i; ) {
                    this.addEventListener(types[--i], handler, false);
                }
            } else {
                this.onmousewheel = handler;
            }
        },

        teardown: function () {
            if (this.removeEventListener) {
                for (var i = types.length; i; ) {
                    this.removeEventListener(types[--i], handler, false);
                }
            } else {
                this.onmousewheel = null;
            }
        }
    };

    $.fn.extend({
        mousewheel: function (fn) {
            return fn ? this.bind("mousewheel", fn) : this.trigger("mousewheel");
        },

        unmousewheel: function (fn) {
            return this.unbind("mousewheel", fn);
        }
    });

    /**
    * @function
    * @property {object} jQuery plugin which runs handler function once specified element is inserted into the DOM
    * @param {function} handler A function to execute at the time when the element is inserted
    * @param {bool} shouldRunHandlerOnce Optional: if true, handler is unbound after its first invocation
    * @example $(selector).waitUntilExists(function);
    */

    $.fn.waitUntilExists = function (handler, shouldRunHandlerOnce, isChild) {
        var found = 'found';
        var $this = $(this.selector);
        var $elements = $this.not(function () { return $(this).data(found); }).each(handler).data(found, true);

        if (!isChild) {
            (window.waitUntilExists_Intervals = window.waitUntilExists_Intervals || {})[this.selector] =
                window.setInterval(function () { $this.waitUntilExists(handler, shouldRunHandlerOnce, true); }, 500)
            ;
        }
        else if (shouldRunHandlerOnce && $elements.length) {
            window.clearInterval(window.waitUntilExists_Intervals[this.selector]);
        }

        return $this;
    }

    function handler(event) {
        var orgEvent = event || window.event, args = [].slice.call(arguments, 1), delta = 0, returnValue = true, deltaX = 0, deltaY = 0;
        event = $.event.fix(orgEvent);
        event.type = "mousewheel";

        // Old school scrollwheel delta
        if (orgEvent.wheelDelta) { delta = orgEvent.wheelDelta / 120; }
        if (orgEvent.detail) { delta = -orgEvent.detail / 3; }

        // New school multidimensional scroll (touchpads) deltas
        deltaY = delta;

        // Gecko
        if (orgEvent.axis !== undefined && orgEvent.axis === orgEvent.HORIZONTAL_AXIS) {
            deltaY = 0;
            deltaX = -1 * delta;
        }

        // Webkit
        if (orgEvent.wheelDeltaY !== undefined) { deltaY = orgEvent.wheelDeltaY / 120; }
        if (orgEvent.wheelDeltaX !== undefined) { deltaX = -1 * orgEvent.wheelDeltaX / 120; }

        // Add event and delta to the front of the arguments
        args.unshift(event, delta, deltaX, deltaY);

        return ($.event.dispatch || $.event.handle).apply(this, args);
    }

})(jQuery);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.JQueryUtils.js